import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("显示")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("不显示")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "交易信息" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.config,
          "label-col": { span: 2 },
          "wrapper-col": { span:8 },
          autocomplete: "off",
          onFinish: _ctx.onFinish
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "显示库存" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.config.is_show_stock,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.is_show_stock) = $event)),
                  name: "radioGroup"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "下单赠送成长值比例" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.config.money_to_growth,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.money_to_growth) = $event)),
                  placeholder: "请输入下单赠送成长值比例"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "未付款自动取消时长" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.config.unpaid_order_cancel_time,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.unpaid_order_cancel_time) = $event)),
                  placeholder: "请输入未付款自动取消时长",
                  "addon-after": "分钟"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "已支付允许取消时长" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.config.paid_order_cancel_time,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.config.paid_order_cancel_time) = $event)),
                  placeholder: "请输入已支付允许取消时长",
                  "addon-after": "分钟"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "已发货订单自动完成时长" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.config.order_auto_receipt_days,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.config.order_auto_receipt_days) = $event)),
                  placeholder: "请输入已发货订单自动完成时长",
                  "addon-after": "天"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "已完成订单售后退款时长" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.config.order_after_sale_days,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.config.order_after_sale_days) = $event)),
                  placeholder: "请输入已完成订单售后退款时长",
                  "addon-after": "天"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { "wrapper-col": { offset: 2, span: 8 } }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  "html-type": "submit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "onFinish"])
      ]),
      _: 1
    })
  ]))
}